import React from "react"
import { useTranslation } from "react-i18next"

import { ReadonlyField } from "@/nzds/forms/readonly-field/readonly-field"
import { getDisplayListValue, getDisplayValue } from "@/utils/value"

interface CredentialIdentityReadonlyFieldsProps {
  providerName: string
  resources: string[]
}

export const CredentialIdentityReadonlyFields: React.FC<
  CredentialIdentityReadonlyFieldsProps
> = ({ providerName, resources }) => {
  const { t } = useTranslation("common")

  return (
    <>
      <ReadonlyField
        helperText={t("admin.credentialsUi.providerReadonlyHelperText")}
        label={t("fields.utilityCredential.title")}
        value={getDisplayValue(providerName)}
      />
      <ReadonlyField
        helperText={t("admin.credentialsUi.resourcesHelperText")}
        label={t("admin.credentialsUi.resourcesLabel")}
        value={getDisplayListValue(resources)}
      />
    </>
  )
}
